export const tableColumn = [
  {
    title: "服务器名",
    slot: "game_name",
    align: "center",
    width: 116,
  },
  {
    title: "服务器IP",
    slot: "game_version_name",
    align: "center",
    width: 78,
  },
  {
    title: "开区时间 月/日/时",
    slot: "date",
    align: "center",
    width: 154,
  },
  {
    title: "线路类型",
    key: "game_tags",
    align: "center",
    width: 116,
  },
  {
    title: "版本介绍",
    slot: "game_desc",
    align: "center",
    width: 290,
  },
  {
    title: "客服QQ",
    slot: "labelList",
    align: "center",
    width: 154,
  },
  {
    title: "详细介绍",
    slot: "detail",
    align: "center",
    width: 116,
  },
];

export const returnLabel = (list, version, featrue) => {
  const labelList = JSON.parse(
    JSON.stringify(list.map((item) => item.labelName))
  );
  let exchangeList = [];
  if (labelList.length < 3) {
    exchangeList = labelList;
  } else {
    exchangeList = labelList.filter((item) => item !== version);
    exchangeList = exchangeList.filter((item) => item !== featrue);
  }
  return exchangeList.join("/");
};

export interface BasePcList {
  id: string;
  name: string;
  path: string;
  desc?: string; // 描述
  link?: string; // 只需 pc
  pcLink?: string; // 需要多个下载 pc
  azLink?: string; // 需要多个下载 az
  iosLink?: string; // 需要多个下载 ios
  sendAplus?: boolean; // 需要发送(window as any).aplus_queue
  isRequest?: boolean; // 需要百度转化API上报
  isSougouJs?: boolean; // 需要发送搜狗js
  isBaiduApiToken?: string; // 需要百度上报apitoken拼接
  IDX?: number; // 类型1 代表360 不传则是百度 后面又其他的再新增类型
  key?: string; // 需要360上报api拼接
  Secret?: string; // 需要360上报api拼接
  isCustom?: boolean; // 需要自定义特殊处理
  filename?: string; // 文件名
  fisrtFileName?: string; // 需特殊拼接文件名前
  lastFileName?: string; // 需特殊拼接文件名后
}

export const basePcList: BasePcList[] = [
  {
    id: "10001",
    name: "sw",
    path: "/sw",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned@6092.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken: "",
    filename: "996boxV340SetupSigned@6092.exe",
    fisrtFileName: "996boxV340SetupSigned'web2detail,id=",
    lastFileName: "'@6092.exe",
  },
  {
    id: "10002",
    name: "sw/gameDetail",
    path: "/sw/gameDetail",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned@6092.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken: "",
    filename: "996boxV340SetupSigned@6092.exe",
    fisrtFileName: "996boxV340SetupSigned'web2detail,id=",
    lastFileName: "'@6092.exe",
  },
];
